{
  "simulator": {
    "matchFacts": "الأولوية {{priority}}، درجة التحديد {{specificity}}"
  },
  "budget": {
    "filterTitle": "تصفية الميزانيات",
    "showBudgets": "عرض الميزانيات",
    "showCount": "عرض الميزانيات: {{count}}",
    "category": "الفئة"
  },
  "puxTenant": {
    "noMatch": "لا توجد ميزانيات تطابق هذه المرشحات",
    "auditNoMatch": "لا توجد سجلات تدقيق تطابق هذه المرشحات",
    "rfqStatus": "حالة الاستفسار",
    "rfqOnly": "ينطبق على الاستفسارات فقط؛ تبقى الاحتياجات التي لم يبدأ شراؤها ظاهرة.",
    "sourcingNoMatch": "لا توجد أعمال شراء تطابق هذه المرشحات",
    "approvalSearch": "البحث برقم الطلب أو مقدم الطلب",
    "approvalSearchPlaceholder": "رقم الطلب أو مقدم الطلب",
    "approvalAttention": "ما يحتاج إلى انتباه",
    "approvalOverdue": "المتأخرة فقط",
    "approvalDelegated": "بالنيابة عن الآخرين فقط",
    "approvalNoMatch": "لا توجد اعتمادات تطابق هذه المرشحات",
    "copyFailed": "النسخ غير متاح. حدد المرجع وانسخه.",
    "rfqStates": {
      "draft": "مسودة",
      "open": "مفتوح",
      "awarded": "تمت الترسية",
      "no_award": "دون ترسية",
      "cancelled": "ملغى"
    },
    "deliveryExceptions": "استثناءات التسليم"
  }
}
